import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  list: [],
  total_list: 0,
  pagination: { num_page: 0, num_items: 20 },
  current_filters: {}
};

// getters
const getters = {
  getList: (state, getters, rootState) => type => {
    var aCompanys = [];
    for (var i in state.list) {
      if (state.list[i].visible) aCompanys.push(state.list[i]);
    }
    return aCompanys;
  },

  getTotalList: (state, getters, rootState) => () => {
    return state.total_list;
  },

  get_by_id: (state, getters, rootState) => id => {
    if (typeof state.list[id] !== "undefined") return state.list[id];
    return false;
  }
};

// actions
const actions = {
  loadList({ commit, state }, event) {
    // console.log("loadCategories() with type - "+ type);

    var path =
      "company" + (typeof event !== "undefined" ? "/event/" + event : "");
    var page_options = params.page_options
      ? params.page_options
      : state.pagination;
    var filters = params.filters ? params.filters : state.current_filters;
    var oParams = Object.assign(filters ? filters : {}, page_options);

    return api.post(path, oParams).then(function(response) {
      if (response.status) {
        var data = response.data.data;
        for (var i in data) {
          data[i].visible = true;
        }

        commit("setList", { data: data, total: response.data.total });
        return commit("setPagination", page_options);
      }
    });
  },

  load_by_id({ commit }, id) {
    var path = "company/" + id;
    return api.get(path).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        return commit("addCompany", data);
      }
    });
  }
};

// mutations
const mutations = {
  setList(state, data) {
    state.list = data.data;
    state.total_list = data.total;
  },

  addCompany(state, company) {
    var list = { ...state.list };
    list[company.id] = company;

    state.list = list;
  },

  addNote(state, { id, note }) {
    var list = { ...state.list };
    list[id].notes[note.id] = note;

    state.list = list;
  },

  removeNote(state, { id, note }) {
    var list = { ...state.list };
    delete list[id].notes[note];

    state.list = list;
  },

  applyFilters(state, filters) {
    state.current_filters = filters;
    // var list = {...state.list};
    // if( !filters ){
    //     for( var i in list ){
    //         list[ i ].visible = true;
    //     }
    // }
    // else {
    //     for( var i in list ){
    //         list[ i ].visible = false;
    //     }
    //     for( var i in list ){
    //         var item = list[ i ];
    //         // console.log( " ---- ITEM " + item.name + " --- " );
    //         var bFound = true;
    //         for( var k in filters ){
    //             var item_value = ( typeof item[k] == 'object' )? item[k].id : item[k];
    //             // console.log( "ITEM: " + item[k] + " - FILTER: " + filters[k] );
    //             if( item.hasOwnProperty( k ) && filters[ k ] != item_value ) {
    //               bFound = false;
    //             }
    //         }

    //         list[ i ].visible = bFound;

    //     }
    // }

    // state.list = list;
  },
  setPagination(state, value) {
    state.pagination = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
